<template>
  <RygenChip
    class="waterfall-tender-rate-quote-status-chip"
    :label="statusLabel"
    :severity="severity"
  />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';

import { translateEnum } from '@rygen/rygen-ui/i18n';
import { Severity } from '@rygen/rygen-ui/model';

import { TenderResponseCode, WaterfallTenderRateQuoteStatus } from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  status: {
    type: String as PropType<WaterfallTenderRateQuoteStatus>,
    default: () => 'LOADING',
  },
  tenderResponseCode: {
    type: String as PropType<TenderResponseCode>,
    default: () => undefined,
  },
});
const { status, tenderResponseCode } = toRefs(props);

const statusLabel = computed(() => {
  if (
    status.value === WaterfallTenderRateQuoteStatus.COMPLETED &&
    tenderResponseCode?.value
  ) {
    return translateEnum(tenderResponseCode.value, 'TenderResponseCode');
  }

  return translateEnum(status.value, 'WaterfallTenderRateQuoteStatus');
});

const severity = computed((): Severity | undefined => {
  switch (status.value) {
    case WaterfallTenderRateQuoteStatus.COMPLETED:
      return tenderResponseCode?.value ===
        TenderResponseCode.RESERVATION_ACCEPTED
        ? Severity.SUCCESS
        : Severity.DANGER;
    case WaterfallTenderRateQuoteStatus.FAILED_TO_TENDER:
    case WaterfallTenderRateQuoteStatus.CANCELED:
      return Severity.DANGER;
    case WaterfallTenderRateQuoteStatus.PENDING:
      return Severity.INFO_LIGHT;
    case WaterfallTenderRateQuoteStatus.TENDERED:
      return Severity.INFO;
    default:
      return undefined;
  }
});
</script>
